import { render, staticRenderFns } from "./OperRole.vue?vue&type=template&id=abdff200&scoped=true&"
import script from "./OperRole.vue?vue&type=script&lang=js&"
export * from "./OperRole.vue?vue&type=script&lang=js&"
import style0 from "./OperRole.vue?vue&type=style&index=0&id=abdff200&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abdff200",
  null
  
)

export default component.exports